export function canUseWindow() {
  return typeof window !== "undefined";
}
